// store/mainChat/index.js

import * as mutations from "./mutations";
import * as actions from "./actions";

export default {
    namespaced: true,

    state: {
        // ============ UNIFIED CONVERSATIONS (PRIMARY) ============
        conversations: {
            data: [],
            payload: null,
            isLoading: false,
            lastFetched: null,
        },
        conversationPayload: {},
        chats: { snap: null, data: [] },
        chatPaylaod: {},
        groupChats: { snap: null, data: [] },
        groupChatPayload: {},
        mainChatProjects: { snap: null, data: [] },
        mainChatSprints: { snap: null, data: {} },
        mainChatFolders: { snap: null, data: {} },
        commentRoomData: {},
        conversationRoomData: {},
    },

    getters: {
        conversations: (state) => state.conversations,
        conversationsList: (state) => state.conversations?.data || [],
        groupChatConversations: (state) => {
            return (state.conversations?.data || []).filter(c => c.chatType === 'groupChat');
        },
        oneToOneConversations: (state) => {
            return (state.conversations?.data || []).filter(c => c.chatType === 'oneToOne');
        },
        getConversationById: (state) => (id) => {
            return (state.conversations?.data || []).find(
                c => String(c._id || c.id) === String(id)
            );
        },
        isConversationsLoading: (state) => state.conversations?.isLoading || false,
        chats: (state) => state.chats,
        groupChats: (state) => state.groupChats,
        getGroupChatPayload: (state) => state.conversationPayload,
        getChatPayload: (state) => state.chatPaylaod,
        mainChatProjects: (state) => {
            return state.mainChatProjects;
        },
        mainChatSprints: (state) => {
            return state.mainChatSprints;
        },
        mainChatFolders: (state) => {
            return state.mainChatFolders;
        },
        getCommentRoomData: (state) => state.commentRoomData,
        getConversationRoomData: (state) => state.conversationRoomData,
    },
    mutations,
    actions
};
